"use strict";

var LoggerInstance = require("js-logger").get("SponsorshipHelper");

var SponsorshipHelper = class {

	/**
	 * Calculate a new per-payment amount based on the newly-selected frequency
	 * @param {int} defaultAmount default amount set in the sponsorship defaults wizard
	 * @param {string} selectedFrequency new frequency selected from sponsorship/my account page
	 * @param {string} initialFrequency the frequency used for the defaultAmount
	 * @returns {int} updated per-payment amount
	 */
	calculateUpdatedTotal(defaultAmount, selectedFrequency, initialFrequency) {
		defaultAmount = Number(defaultAmount);

		if (initialFrequency && initialFrequency !== "M") {
			if (selectedFrequency === initialFrequency) {
				return defaultAmount;
			}

			//Converting the defaultAmount to the appropriate amount for monthly frequency
			switch (initialFrequency) {
				case "A":
					defaultAmount /= 12;
					break;
				case "S":
					defaultAmount /= 6;
					break;
				case "Q":
					defaultAmount /= 3;
					break;
				default:
					LoggerInstance.error(`Initial frequency ${selectedFrequency} is not supported.`);
					return defaultAmount;
			}
		}
		//Converting monthly frequency to the appropriate amount for the selectedFrequency
		switch (selectedFrequency) {
			case "A":
				//Doing a ceiling on the hundreths decimal place because the possible division up above can produce some ugly decimals
				//Using the approach found here: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/ceil#Decimal_adjustment
				return +(Math.ceil(defaultAmount * 12 + "e+2")  + "e-2");
			case "S":
				return +(Math.ceil(defaultAmount * 6 + "e+2")  + "e-2");
			case "Q":
				return +(Math.ceil(defaultAmount * 3 + "e+2")  + "e-2");
			case "M":
				return +(Math.ceil(defaultAmount + "e+2")  + "e-2");
			default:
				LoggerInstance.error(`Select frequency ${selectedFrequency} is not supported.`);
				return +(Math.ceil(defaultAmount + "e+2")  + "e-2");;
		}
	}

	getChildSponsorshipTagHelperAttributes() {
		// These values are also in Common.Components.Helpers.SponsorshipHelper
		return {
			"aso-child-sponsorship-availability": true,
			"aso-data-tangible": '@Model?.Tangible',
			"aso-data-user-id": "@ViewBag.UserId",
			"is-design-mode": "@ViewBag.IsDesignMode"
		};
	}

	calculateUpdatedTotalForMySponsorships($editSponsorship, currentFrequencyValue) {
		var defaultAmount = $editSponsorship.attr("data-pledge-amount");
		var initialFrequency = $editSponsorship.attr("data-pledge-initial-frequency");

		return this.calculateUpdatedTotal(+defaultAmount, currentFrequencyValue, initialFrequency);
	}
};

module.exports = new SponsorshipHelper();
